import { create } from "zustand";

interface LoginSlideOverState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export const useLoginSlideOverStore = create<LoginSlideOverState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));